import tenantMenuItemsData from '@/backend/data/tenant_menu_items.json';

export const mainMenuItems =
  tenantMenuItemsData?.tenant_menu_items?.filter(
    (item) => item.id !== 'configuration'
  ) || [];

export const adminMenuItems =
  tenantMenuItemsData?.tenant_menu_items?.filter(
    (item) => item.id === 'configuration'
  ) || [];

export const allMenuItems = [...mainMenuItems, ...adminMenuItems];

export const getMenuItemChildren = (id, menuItems) => {
  const item = menuItems.find((menuItem) => menuItem.id === id);
  return item ? item.children : [];
};

export const getMenuItemById = (id, menuItems) => {
  return menuItems.find((menuItem) => menuItem.id === id);
};
